jQuery(function ($) {

  const responsive = {
    md: 2,
    xl: 3,
    xxl: 4,
  };


  function init($wrap) {
    const $dots_nav = $('.dots-nav', $wrap);
    const $live = $('.live', $wrap);
    const $slider = $('tbody', $wrap);
    const $slides = $('tr', $slider);
    const slides_to_show = Math.min($slides.length, Math.max(1, ...Object.entries(responsive).filter(entry => ThemeJS.Media_Queries.is_at_least(entry[0])).map(entry => entry[1])));
    const num_pages = Math.ceil($slides.length / slides_to_show);
    $wrap.get(0).style.setProperty('--num-slides', $slides.length);
    $wrap.get(0).style.setProperty('--slides-shown', slides_to_show);

    $live.attr('aria-live', 'off');
    $wrap.off('click', '.dots-nav button', handle_dot_click);

    if (ThemeJS.Media_Queries.is_at_least('md')) {
      resize_cells($wrap);

      if (num_pages > 1) {
        const btn_format = $dots_nav.data('btn-format');
        const $dots = $('<ul>').addClass('slick-dots');
        for (var i = 1; i <= num_pages; i++) {
          const btn_text = btn_format.replace('%d', i);
          $dots.append($(`<li><button><span class="sr-only">${btn_text}</button></li>`));
        }
        $dots_nav.html($dots);
      } else {
        $dots_nav.empty();
      }

      let page_index = parseInt(getComputedStyle($wrap.get(0)).getPropertyValue('--current-page-index'));
      page_index = isNaN(page_index) ? 0 : page_index;
      page_index = Math.min(0, Math.max(num_pages, page_index));
      set_slider_page($wrap, page_index);

      $wrap.on('click', '.dots-nav button', handle_dot_click);
      $live.attr('aria-live', 'polite');
    } else {
      $dots_nav.empty();
    }
  }


  function set_slider_page($wrap, page_index) {
    $wrap.get(0).style.setProperty('--current-page-index', page_index);
    const slides_shown = parseInt(getComputedStyle($wrap.get(0)).getPropertyValue('--slides-shown'));
    const min_index = slides_shown * page_index;
    const max_shown = min_index + slides_shown - 1;
    $('tbody tr', $wrap).each(function () {
      let slide_index = $(this).index();
      let is_active = (min_index <= slide_index) && (slide_index <= max_shown);
      $(this).attr('aria-hidden', !is_active);
    });
    $('.live', $wrap).html($('<ul>').append($('tbody tr:not([aria-hidden=true])').toArray().map(tr => {
      return $('<li>').append($('.content-wrap', tr).toArray().map(wrap => $(wrap).html()).join('')).prop('outerHTML');
    }).join('')));
    $('.slick-dots li', $wrap).each(function () {
      $(this).toggleClass('slick-active', $(this).index() == page_index);
    });
  }


  function handle_dot_click() {
    // scoped to button element
    set_slider_page($(this).closest('.sliding-table'), $(this).parent().index());
  }


  function resize_cells($wrap) {
    const num_rows = $('th', $wrap).length;
    for (let i = 1; i <= num_rows; i++) {
      const $wrappers = $(`tr > *:nth-child(${i}) .content-wrap`);
      const $contents = $('.content', $wrappers);
      const max = Math.max(...$contents.toArray().map(el => $(el).height()));
      $wrappers.height(Math.max(...$contents.toArray().map(el => $(el).height())));
    }
  }



  function init_all() {
    $('.sliding-table').each(function () {
      init($(this));
    });
  }

  init_all();
  $(window).on('breakpoint_changed accordion_opened', init_all);

  $(document).on('shown.bs.tab', function () {
    init_all();
  });
});